import React from 'react';
import { CtPrivacyRepository } from 'common/api/models/ct-privacy.repository';
import { PublicReportDialog } from 'components/report-video/public-report.dialog';
import { ProtectedReportDialog } from 'components/report-video/protected-report.dialog';

export const REPORT_VIDEO_DIALOG = 'reportVideoDialog';

export const ReportVideoDialog = () =>
  CtPrivacyRepository.isPublic() ? <PublicReportDialog /> : <ProtectedReportDialog />;
